import { Placeholder } from './Placeholder';
import { TutorLayout, TutorPrimaryPanel, TutorSecondaryPanel } from './TutorPanels';

/**
 * Provides a loading screen with a message.
 * Shows a placeholder in place of or after the message.
 */
export function ClassyLoading(props: { message?: string }) {
  return (
    <TutorLayout>
      <TutorPrimaryPanel pointer unanimated>
        {props.message ? <span>{props.message}</span> : <Placeholder />}
      </TutorPrimaryPanel>
      {props.message && (
        <TutorSecondaryPanel unanimated>
          <Placeholder />
        </TutorSecondaryPanel>
      )}
    </TutorLayout>
  );
}
